import Moment from "moment";
import store from "../store";

export default {
  install(Vue) {
     Vue.mixin({
      created() {
      }
    });
     /*
    Función que devuelve si estamos en SYS4 conjunto
    */
    Vue.prototype.isSys4Conjunto = function () {
      return store.getters.getParametrosApp.sys4 === 1
    }
    /*
    Función que devuelve si los articulos tienen artbox
    */
    Vue.prototype.tieneArtbox = function () {
      return store.getters.getParametrosApp.artbox === 1
    }
     /*
    Función que devuelve el nombre del informe de etiquetas
    */
    Vue.prototype.getNombreFicheroInforme = function () {
      return store.getters.getParametrosApp.nombre_informe_etiquetas
    }
    /*
    Función que devuelve el json dashboard por defectodel BI
    */
    Vue.prototype.getDashboardDefecto = function () {
      return store.getters.getParametrosApp.dashboard_defecto
    }
    /**
     * Función que te dice si se tactil el dispositivo
     */
    Vue.prototype.isTouchDevice = function () {
     if ("ontouchstart" in document.documentElement) {
       return true
     } else {
       return false
     }
    }
    /*
    Función que controla los permisos
    */
    Vue.prototype.permitido = function (nomPer) {
      let acl = store.getters.getAcl
      if (acl !== null && typeof acl.find((s) => s.permiso===nomPer) !== 'undefined' && acl.find((s) => s.permiso===nomPer).valor === 'S') {
        return true
      } else {
        return false
      }
    }
    // Vue.prototype.isInLikeLists = function (idArtic) {
    //   let likeList = this.$store.getters.getLikeLists
    //   if (likeList.length > 0 ) {
    //     console.log(likeList)
    //   }
    // }
    Vue.filter("shortDate", function (value) {
      return Moment(value).format('DD-MM-YYYY');
    })
  }
}